<template lang="pug">
v-container(fluid fill-height align-start class="tw-py-0 my-0")
  v-row(align="stretch" class="tw-h-full d-flex flex-row flex-grow-1 my-0")
    v-col(class="tw-h-full my-0 py-0")
      v-tabs(vertical class="tw-h-full py-0 my-0 ")
        v-tab
          span {{ $t('Settings.Common.members') }}
        v-tab
          span {{ $t('Settings.Common.invitations') }}

        //Members
        v-tab-item(transition="" class="tw-h-full")
          v-row(v-if="!loading && !loadFailed && members.length > 0" align="stretch" class="tw-h-full  py-0 my-0")
            //Left pane
            v-col(cols="" class="my-0 d-flex flex-column flex-grow-1 min-h-0 fill-height overflow-hidden pl-6")
              v-row(no-gutters class=" d-flex flex-column flex-grow-1 tw-max-h-full flex-shrink-0 tw-min-h-0 my-0")
                v-col(class=" flex-grow-1 d-flex overflow-auto flex-column flex-shrink-0 min-h-0 my-0 ")
                  kubiqa-team-list-item(v-for="member in members" :key="member.id" :item="member")

            //Right pane
            v-col(cols="6" class="tw-flex-col tw-h-full tw-flex tw-ml-0 tw-content-center tw-w-full tw-overflow-hidden")
              div(v-if="this.$route.name == 'settingsTeamItem'" class="tw-relative tw-h-full")
                v-fade-transition(mode="in-out")
                  div(class="tw-z-0 tw-relative tw-h-full")
                    router-view
              div(v-else class="tw-h-full")
                v-fade-transition(mode="in-out")
                  v-row(class=" d-flex flex-row flex-grow-1 tw-h-full flex-shrink-0 tw-z-10 tw-relative")
                    v-col(class="fill-height")
                      v-row(align="center" justify="center" class="fill-height")
                        v-col(cols="auto")
                          div(class="tw-bg-gray-lighten-5 tw-rounded-full tw-text-center tw-p-10")
                            v-img(src="@/assets/images/illustrations/team-avatar.svg" width="220px" class="tw-self-center ")
          v-row(v-else-if="!loading && !loadFailed" align="center" class="fill-height")
            v-col(class="fill-height")
              v-row(align="center" class=" fill-height ")
                v-col(class="fill-height")
                  kubiqa-misc-empty-state(
                    :title="$t('Common.emptyStates.membersTitle')"
                    :description="$t('Common.emptyStates.membersBody')"
                    :action-label="$t('Common.emptyStates.inviteMember')"
                    icon="mdi-account-group-outline"
                    @action="addInvitationDialog = true"
                  )
          v-row(v-else-if="loading" align="center" justify="center" class="fill-height")
            v-progress-circular(indeterminate color="primary" size="48" aria-label="Loading team")
          v-row(v-else align="center" justify="center" class="fill-height")
            kubiqa-misc-empty-state(
              :title="$t('Common.emptyStates.loadErrorTitle')"
              :description="$t('Common.emptyStates.loadErrorBody')"
              :action-label="$t('Common.emptyStates.retry')"
              icon="mdi-alert-circle-outline"
              @action="init"
            )
        //Invitations
        v-tab-item(transition="" class="fill-height  ")
          v-row(no-gutters align="center" justify="space-between" class="tw-bg-gray-lighten-5 pt-0 tw-rounded px-2 ml-4")
            v-col
              span(class=" indigo--text text--lighten-2 tw-text-xl tw-font-bold ") {{ $t('Settings.Common.invitationsSent') }}
            v-col(cols="auto")
              v-btn(outlined color="indigo" @click="(addInvitationDialog = true), key++")
                span {{ $t('Settings.Common.newInvitation') }}
          v-row(class="tw-shadow-inner mt-0  tw-border-t tw-border-gray-lighten-2 ml-4")
            v-col
          v-row(no-gutters class=" fill-height tw-overflow-hidden mx-2")
            v-col(class=" fill-height overflow-hidden ")
              template(v-if="!loading && !loadFailed && invitations.length == 0")
                v-row(justify="center" align="center" class=" fill-height ")
                  v-col(cols="auto" class="text-center ")
                    kubiqa-misc-empty-state(
                      :title="$t('Common.emptyStates.invitationsTitle')"
                      :description="$t('Common.emptyStates.invitationsBody')"
                      :illustration="require('@/assets/images/illustrations/empty-team.svg')"
                    )

              template(v-if="!loading && !loadFailed && invitations.length > 0" class="fill-height")
                v-row(no-gutters class="tw-font-bold text-secondary pb-2 ml-6")
                  v-col
                    span {{ $t('Common.email') }}
                  v-col
                    span {{ $t('Settings.Common.role') }}
                  v-col
                    span {{ $t('Settings.Common.sentOn') }}
                  v-col(cols="1")
                v-row(no-gutters class="fill-height ml-4")
                  v-col(:key="key" class=" overflow-y-scroll fill-height")
                    kubiqa-team-invitation-list-item(v-for="item in invitations" :key="item.id" :item="item")
              div(v-if="loading" class="tw-flex tw-h-full tw-items-center tw-justify-center")
                v-progress-circular(indeterminate color="primary" size="48" aria-label="Loading invitations")
              div(v-else-if="loadFailed" class="tw-flex tw-h-full tw-items-center tw-justify-center")
                kubiqa-misc-empty-state(
                  :title="$t('Common.emptyStates.loadErrorTitle')"
                  :description="$t('Common.emptyStates.loadErrorBody')"
                  :action-label="$t('Common.emptyStates.retry')"
                  compact
                  icon="mdi-alert-circle-outline"
                  @action="init"
                )
    v-dialog(
      v-model="addInvitationDialog"
      max-width="45%"
      height="500"
      hide-overlay
      class="tw-ml-32"
      :key="key"
    )
      div(class="tw-bg-white fill-height")
        kubiqa-team-invitations-add(@close="addInvitationDialog = false" class="fill-height")
</template>
<script>
export default {
  data() {
    return {
      key: 1,
      addInvitationDialog: false,
      loading: true,
      loadFailed: false,
    };
  },
  computed: {
    invitations() {
      return this.$store.getters['team/invitations'];
    },
    members() {
      return this.$store.getters['team/members'];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      const results = await Promise.all([
        this.$store.dispatch('team/getInvitations'),
        this.$store.dispatch('team/getMembers'),
      ]);
      this.key++;
      this.loadFailed = results.some((result) => !Array.isArray(result));
      this.loading = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
a.text-link:hover {
    text-decoration: none !important;
}
</style>
